import { Link } from '@remix-run/react';

import Text from '~/components/Text';

const SidePanelLink = ({
  path,
  text,
  // biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
  asTitle = false,
}: {
  text: string | React.ReactNode;
  path: string;
  asTitle?: boolean;
}) => {
  return (
    <Link to={path}>
      <Text as="span" type="body" theme="navs" weight="medium" className={'text-sm opacity-75 hover:text-wt-primary'}>
        {text}
      </Text>
    </Link>
  );
};

export default SidePanelLink;
